import { WidgetsClientsMain } from '@/widgets/clients';

export const PagesClientsMain = () => <WidgetsClientsMain />;
